var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetUnknownLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#asset-unknown-logo_svg__clip0_1501_29123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z",
    fill: "#000636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.79 18.797c.01-.62.08-1.11.21-1.469.13-.36.396-.758.797-1.195l1.023-1.055c.438-.495.657-1.026.657-1.594 0-.546-.144-.974-.43-1.28-.287-.313-.703-.47-1.25-.47-.531 0-.959.141-1.281.422-.323.281-.485.66-.485 1.133h-1.445c.01-.844.31-1.523.898-2.039.594-.52 1.365-.781 2.313-.781.984 0 1.75.265 2.297.797.552.526.828 1.25.828 2.171 0 .912-.422 1.81-1.266 2.696l-.851.844c-.38.421-.57 1.028-.57 1.82h-1.446zm-.063 2.476c0-.234.07-.43.21-.585.146-.162.36-.243.641-.243s.495.081.64.242a.826.826 0 01.22.586c0 .235-.073.43-.22.586-.145.151-.359.227-.64.227s-.495-.076-.64-.227a.844.844 0 01-.211-.586z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "asset-unknown-logo_svg__clip0_1501_29123"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
}
export default SvgAssetUnknownLogo;